<template>
    <figure class="generic-video youtube-video" v-if="embedUrl">
        <div class="embed-video">
            <div class="container youtube-container"><iframe :src="embedUrl" :title="title" frameborder="0"></iframe></div>
        </div>
        <figcaption v-if="caption">{{ caption }}</figcaption>
    </figure>
</template>

<script>
export default {
    props: {
        url: {
            type: String,
            required: true,
        },
        title: {
            type: String,
            required: false,
        },
        caption: {
            type: String,
            required: false,
        },
    },

    computed: {
        embedUrl() {
            let regExp = /^.*(youtu\.be\/|v\/|u\/\w\/|embed\/|watch\?v=|\&v=)([^#\&\?]*).*/;
            let match = this.url.match(regExp);

            if (match && match[2].length == 11) {
                return "https://youtube.com/embed/" + match[2] + "?modestbranding=1";
            } else {
                return null;
            }
        },
    },
};
</script>
